<div class="help-search">
    <div class="search-input-wrapper">
        <i class="pi pi-search search-icon"></i>
        <input type="text"
               [(ngModel)]="searchQuery"
               (input)="onSearchInput()"
               (focus)="onFocus()"
               (blur)="onBlur()"
               [placeholder]="placeholder"
               class="search-input" />
        <i *ngIf="searchQuery" class="pi pi-times clear-icon" (click)="clearSearch()"></i>
        <i *ngIf="isSearching" class="pi pi-spin pi-spinner spinner-icon"></i>
    </div>

    <!-- Search Results Dropdown -->
    <div *ngIf="showResults" class="search-results">
        <div *ngFor="let result of results"
             class="search-result-item"
             (mousedown)="onResultClick(result)">
            <div class="result-title">{{result.title}}</div>
            <div class="result-snippet" [innerHTML]="result.snippet"></div>
        </div>
        <div *ngIf="results.length === 0 && !isSearching" class="no-results">
            Keine Ergebnisse gefunden.
        </div>
    </div>
</div>
